import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import mitt from 'mitt';
import axios from "axios";
import "vue-multiselect/dist/vue-multiselect.css";
import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { useToast } from "vue-toastification";
import VueApexCharts from "vue3-apexcharts";
 

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
 

import 'primeicons/primeicons.css';
 

import "../src/index.css";
 



export const toast = useToast();
export const emitter = mitt();

const instance = axios.create({
    withCredentials: true,
});
  
instance.interceptors.request.use(function(config:any) {
    const token = localStorage.getItem('AUTH_ID');
    const appId = 10001;
    if(token) {
        // config.headers.common["Authorization"] = 'Bearer ' + token;  
        config.headers.Authorization  = 'Bearer ' + token; 
        config.headers['App-Id'] = appId;  
    }
    return config;
}, function(err:any) {
    return Promise.reject(err);
});

instance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url || "";
      const analyticsApi = process.env.VUE_APP_ANALYTICS_API || "";
      if (analyticsApi && requestUrl.startsWith(analyticsApi)) {
        return Promise.reject(error);
      }
      window.location.href = `${process.env.VUE_APP_AUTH_UI}/?returnTo=${process.env.VUE_APP_MONITOR_UI}`

    }
    return Promise.reject(error);
  });

const app = createApp(App);

app.config.globalProperties.$http = instance;
app.use(router);
app.use(store);
app.use(Toast);
const ApexChartsPlugin: any = (VueApexCharts as any)?.default ?? VueApexCharts;
app.use(ApexChartsPlugin);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options:{ darkModeSelector: '.my-app-dark'},
  }
});
app.mount('#app');